import { incrementItemQuantity } from '@jetshop/core/data/mutations/cartMutations.gql';
import React, { useContext } from 'react';
import { Mutation } from 'react-apollo';
import { CartIdContext } from '../Cart/CartIdContext';
import { getIncrementQuantityOptimisticResponse } from './cartMutationUtils';
import throwErrorInDev from '../../helpers/throwErrorInDev';
const IncrementQuantity = ({ children, cartQuery }) => {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to IncrementQuantity`);
    const { cartId } = useContext(CartIdContext);
    return (React.createElement(Mutation, { mutation: incrementItemQuantity }, (mutate, { client }) => {
        return children((itemId) => {
            return mutate({
                variables: {
                    input: {
                        cartId,
                        itemId
                    }
                },
                optimisticResponse: {
                    incrementItemQuantity: {
                        cart: getIncrementQuantityOptimisticResponse({
                            itemId,
                            client,
                            cartId,
                            cartQuery
                        }),
                        __typename: 'CartMutation'
                    }
                }
            });
        });
    }));
};
export default IncrementQuantity;
//# sourceMappingURL=IncrementQuantity.js.map